import React from 'react';
import PropTypes from 'prop-types';
import { FaSearch } from 'react-icons/fa';
import { YInput } from './YInput';

/**
 * Search field used on hunt log tables (clubs + personal). Matches club-members-search styling.
 */
export function YLogSearchInput({
  id,
  value,
  onChange,
  placeholder = 'Search…',
  ariaLabel = 'Search',
  className = '',
}) {
  return (
    <div className={`y-log-search ${className}`.trim()}>
      <FaSearch className="y-log-search__icon" aria-hidden="true" />
      <YInput
        id={id}
        type="search"
        className="y-log-search__input"
        placeholder={placeholder}
        aria-label={ariaLabel}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

YLogSearchInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
};
